// Ninfa Flow Rules Configuration
// This file defines which options are available for each Ninfa model based on the selected category

export const NINFA_FLOW_RULES = {
    'NINFA 106': [
        {
            category: 'C2-T', // PUNTO B = 1
            finishOptions: 'ALL', // PUNTO C = TUTTI
            glassOptions: ['8+8_SG', '8+8_EVA', '10+10_SG', '10+10_EVA'], // PUNTO D
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'], // PUNTO E = TUTTI
            drainageHoles: ['SI', 'NO'], // PUNTO F = SI-NO
            milling: ['SI', 'NO'], // PUNTO G = SI-NO
            plates: ['SI', 'NO'] // PUNTO H = SI-NO
        },
        {
            category: 'C3-T', // PUNTO B = 2
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '10+10_EVA'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C2-C', // PUNTO B = 4
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '10+10_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-C', // PUNTO B = 5
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        }
    ],
    'NINFA 56': [
        {
            category: 'C2-T',
            finishOptions: 'ALL',
            glassOptions: ['6+6_SG', '8+8_SG', '8+8_EVA'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['NO']
        },
        {
            category: 'C3-T',
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '8+8_EVA'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['NO']
        },
        {
            category: 'C2-C', // PUNTO B = 4
            finishOptions: 'ALL',
            glassOptions: ['6+6_SG', '8+8_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['NO']
        }
    ],
    'NINFA 6': [
        {
            category: 'C2-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '10+10_EVA', '12+12_SG', '12+12_EVA'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '10+10_EVA', '12+12_SG', '12+12_EVA'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'UNI132003-T',
            finishOptions: 'ALL',
            glassOptions: ['12+12_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C2-C', // PUNTO B = 4
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '12+12_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-C', // PUNTO B = 5
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '12+12_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['SI', 'NO']
        }
    ],
    'NINFA 116': [
        {
            category: 'C2-T',
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '8+8_EVA', '10+10_SG', '10+10_EVA'],
            fixingOptions: ['INOX_A4_300', 'ZINCATO_A4_300'],
            drainageHoles: ['SI', 'NO'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '10+10_EVA'],
            fixingOptions: ['INOX_A4_300', 'ZINCATO_A4_300'],
            drainageHoles: ['SI', 'NO'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C2-C', // PUNTO B = 4
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '10+10_SG'],
            fixingOptions: ['INOX_A4_300', 'ZINCATO_A4_300'],
            drainageHoles: ['SI', 'NO'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-C', // PUNTO B = 5
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG'],
            fixingOptions: ['INOX_A4_300', 'ZINCATO_A4_300'],
            drainageHoles: ['SI', 'NO'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        }
    ],
    'NINFA 6 STADIO': [
        {
            category: 'C3-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '12+12_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['NO']
        },
        {
            category: 'UNI132003-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '12+12_SG'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['SI', 'NO'],
            plates: ['NO']
        }
    ],
    'NINFA 176': [
        {
            category: 'C2-T',
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '8+8_EVA', '10+10_SG', '10+10_EVA'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '10+10_EVA', '12+12_SG', '12+12_EVA'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C2-C', // PUNTO B = 4
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-C', // PUNTO B = 5
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '12+12_SG'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        }
    ],
    'NINFA 186': [
        {
            category: 'C2-T',
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '8+8_EVA', '10+10_SG', '10+10_EVA', '12+12_SG', '12+12_EVA'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-T',
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '10+10_EVA', '12+12_SG', '12+12_EVA'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C2-C', // PUNTO B = 4
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        },
        {
            category: 'C3-C', // PUNTO B = 5
            finishOptions: 'ALL',
            glassOptions: ['10+10_SG', '12+12_SG'],
            fixingOptions: ['INOX_A4_SF', 'ZINCATO_A4_FS'],
            drainageHoles: ['SI'],
            milling: ['NO'],
            plates: ['SI', 'NO']
        }
    ],
    'NINFA 50N': [
        {
            category: 'C2-T',
            finishOptions: 'ALL',
            glassOptions: ['8+8_SG', '8+8_EVA'],
            fixingOptions: ['INOX_A4_200', 'ZINCATO_A4_200'],
            drainageHoles: ['SI', 'NO'],
            milling: ['NO'],
            plates: ['NO']
        }
    ]
};

// Helper function to get available options for a specific Ninfa model and category
export const getAvailableOptions = (ninfaModel, category) => {
    const modelRules = NINFA_FLOW_RULES[ninfaModel];
    if (!modelRules) return null;

    return modelRules.find(rule => rule.category === category);
};

// Helper function to filter options based on rules
export const filterOptionsByRules = (allOptions, allowedKeys, keyField = 'value') => {
    if (allowedKeys === 'ALL') return allOptions;
    if (!Array.isArray(allowedKeys)) return [];

    return allOptions.filter(option => allowedKeys.includes(option[keyField]));
};
